import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 9/10;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 9 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.84 0H.16A.161.161 0 0 0 0 .162V2.1c0 .09.072.162.16.162h1.286c.09 0 .161-.073.161-.162v-.485h2.09v6.462h-.804a.161.161 0 0 0-.16.161v1.293c0 .089.071.161.16.161h3.214c.089 0 .16-.072.16-.161V8.238a.161.161 0 0 0-.16-.161h-.803V1.615h2.089V2.1c0 .09.072.162.16.162H8.84c.089 0 .161-.073.161-.162V.162A.161.161 0 0 0 8.84 0z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconText extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
